// extracted by mini-css-extract-plugin
export var card = "WebinarCard-module--card--1yIMc";
export var image = "WebinarCard-module--image--3Vqdo";